import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { IConfigResponseDetails } from '@store/reducers/config.reducer';
import { fetchConfig as callConfig } from 'fmc-digital-common';
import { config } from '../config';
import { v4 } from 'uuid';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchConfig } from '@store/actions/config.actions';

export const useHomeConfig = () => {
    const dispatch = useDispatch();
    const query = useQuery<AxiosResponse<IConfigResponseDetails>, any>({
        queryKey: ['home'],
        queryFn: async () =>
            await callConfig({
                baseURL: `${config.env('configUrl')}`,
                headers: {
                    'x-correlation-id': v4().toString(),
                    'x-api-key': `${config.env('xApiKey')}`
                },
                params: {
                    dynamic_node: 'features'
                }
            }),
        useErrorBoundary: false
    });
    useEffect(() => {
        if (query.isSuccess) {
            dispatch(fetchConfig.success(query.data.data));
        } else if (query.isError) {
            dispatch(fetchConfig.failure(query.error));
        }
    }, [query.isSuccess, query.isError]);
    return query;
};
